











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {AdminConfig} from '@/model/resource/AdminConfig'
import {AdminConfigCollection} from '@/model/collection/AdminConfigCollection'
import {ListAdminConfigSchema} from '@/schema/resource/AdminConfig/ListAdminConfigSchema'
import {CsvAdminConfigSchema} from '@/schema/resource/AdminConfig/CsvAdminConfigSchema'

@Component
export default class ListAdminConfigView extends Mixins(MixinQueryRouter) {
  schema = new ListAdminConfigSchema()
  collection = new AdminConfigCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: AdminConfig) {
    Helper.pushByName('editAdminConfig', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new AdminConfigCollection().clearFilters().addFilter(params)

    await csv.listCsvAdminConfig()
    new CsvAdminConfigSchema().downloadCsv(csv.all())
  }
}
